<template>
  <div class="scope-fields">
    <p class="section-help">
      Only these employees can be given this award and see it in the app. Pick from more than one field and an employee
      must match all of them.
    </p>

    <audience-editor
      :scope="scope"
      :scope-fields="fields"
      :saved-total="totalCount"
      @update:scope="$emit('update:scope', $event)"
    />

    <small v-if="scopeError" class="text-danger">{{ scopeError }}</small>
  </div>
</template>

<script>
import { computed } from 'vue';
import AudienceEditor from '@/pages/recognition/components/audience/AudienceEditor.vue';

export default {
  name: 'AwardScopeFields',
  components: { AudienceEditor },
  props: {
    // Per field: [] = everyone, [values] = those values, null = not chosen yet.
    scope: { type: Object, default: () => ({}) },
    scopeFields: { type: Array, default: () => [] },
    scopeError: { type: String, default: '' },
    // Company headcount from forms that already load every employee (null while loading).
    totalCount: { type: Number, default: undefined },
  },
  emits: ['update:scope'],
  setup(props) {
    // The API labels divisions "Divisions"; every other field is singular, so match them.
    const fields = computed(() => props.scopeFields.map(f => (f.key === 'division' ? { ...f, label: 'Division' } : f)));
    return { fields };
  },
};
</script>

<style scoped lang="scss">
@import '@/pages/recognition/styles/award-form';

.scope-fields {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
</style>
